function isNumeric (n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

function copyFields (obj) {
    const ret = {}; // performance.timing object is immutable
    // eslint-disable-next-line guard-for-in
    for (const key in obj) {
        const field = obj[key];
        if (isNumeric(field)) {
            ret[key] = obj[key];
        }
    }
    return ret;
}

function getTimings () {
    // performance.timing object is immutable
    const times = copyFields(window.performance.timing);


    // Enhance with time to first paint if possible
    if (times.firstPaint === undefined) {
        if (window.chrome && window.chrome.loadTimes) {
            // Chrome
            times.firstPaint = window.chrome.loadTimes().firstPaintTime * 1000;
        } else if (typeof window.performance.timing.msFirstPaint === 'number') {
            // IE
            times.firstPaint = window.performance.timing.msFirstPaint;
        }
    }

    return times;
}

function sendTimes (url, times) {
    const conn = new XMLHttpRequest();
    conn.open('POST', url);
    conn.setRequestHeader('Content-Type', 'text/json');
    conn.send(JSON.stringify(times));
}


export function collectTimings (appName, reportUrl = '/clientstats.html') {
    if (appName) {
        try {
            const times = getTimings();
            times.appName = appName;
            times.path = window.location.pathname;
            sendTimes(reportUrl, times);
        } catch (e) {
            return e;
        }
    }
}

export function collectWhenLoaded (appName, reportUrl) {
    window.addEventListener('load', () => {
        window.setTimeout(() => collectTimings(appName, reportUrl), 1);
    });
}



// WEBPACK FOOTER //
// timing.js